import React, { useState } from 'react';
import { useRecordContext } from 'react-admin';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Divider
} from '@mui/material';

const formatDate = (dateStr) =>
  dateStr ? new Date(dateStr).toLocaleDateString() : 'N/A';
const getNested = (obj, path) =>
    path.split('.').reduce((acc, part) => acc?.[part], obj);
  
const LabelValue = ({ label, value }) => (
  <>
    <Grid item xs={4}>
      <Typography variant="body2" fontWeight="bold" color="textSecondary">
        {label}
      </Typography>
    </Grid>
    <Grid item xs={8}>
      <Typography variant="body2">{value ?? 'N/A'}</Typography>
    </Grid>
  </>
);

const NegotiationOfferDialog = () => {
  const record = useRecordContext();
  const [open, setOpen] = useState(false);

  if (!record) return null;

  const negotiation = record.negotiation;
 

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
  
   <Typography
              onClick={
                handleOpen}
              variant="body2"
              color="primary"
              sx={{ textDecoration: 'underline', cursor: 'pointer', display: 'inline' }}
            >
         {negotiation.id}
      </Typography>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle>Negotiation Details</DialogTitle>
        <DialogContent dividers>
   

          <Typography variant="h6" gutterBottom>Negotiation Info</Typography>
          <Grid container spacing={2}>
            <LabelValue label="Negotiation ID" value={negotiation.id} />
            <LabelValue label="Type" value={negotiation.type} />
            <LabelValue label="Trade Type" value={negotiation.tradeType} />
            <LabelValue label="Quantity" value={negotiation.quantity} />
            <LabelValue label="Status" value={negotiation.status} />
            <LabelValue label="Created At" value={formatDate(negotiation.createdAt)} />
          </Grid>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" gutterBottom>Buyer Info</Typography>
          <Grid container spacing={2}>
            <LabelValue label="Name" value={negotiation.buyer?.name} />
            <LabelValue label="Phone" value={negotiation.buyer?.phonenumber} />
            <LabelValue label="Type" value={negotiation.buyer?.type} />
            <LabelValue label="Cooperative Type" value={negotiation.buyer?.cooperativeType} />
            <LabelValue label="Is Verified" value={negotiation.buyer?.isVerified ? 'Yes' : 'No'} />
            <LabelValue label="Is Subscribed" value={negotiation.buyer?.isSubscribed ? 'Yes' : 'No'} />
          </Grid>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" gutterBottom>Seller Info</Typography>
          <Grid container spacing={2}>
            <LabelValue label="Name" value={negotiation.seller?.name} />
            <LabelValue label="Phone" value={negotiation.seller?.phonenumber} />
            <LabelValue label="Type" value={negotiation.seller?.type} />
            <LabelValue label="Cooperative Type" value={negotiation.seller?.cooperativeType} />
            <LabelValue label="Is Verified" value={negotiation.seller?.isVerified ? 'Yes' : 'No'} />
            <LabelValue label="Is Subscribed" value={negotiation.seller?.isSubscribed ? 'Yes' : 'No'} />
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained">Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NegotiationOfferDialog;
